/**
 * Extracts up to two uppercase initials from a full name.
 * "Marie-Claire Dupont" → "MD", "Jean" → "J".
 * Falls back to "?" for empty input.
 */
export function getInitials(fullName: string): string {
  const parts = fullName.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "?";
  if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
  return (
    parts[0].charAt(0).toUpperCase() +
    parts[parts.length - 1].charAt(0).toUpperCase()
  );
}

/**
 * Extracts two initials from split first/last name, handling the
 * executive-specific case where firstName may contain comma-joined
 * prenoms ("Jean,Marie") — only the first one is used.
 */
export function getInitialsFromParts(
  firstName: string | null | undefined,
  lastName: string | null | undefined,
): string {
  const first = (firstName ?? "").split(",")[0]?.trim() ?? "";
  const last = (lastName ?? "").trim();
  const a = first.charAt(0).toUpperCase();
  const b = last.charAt(0).toUpperCase();
  if (!a && !b) return "?";
  return `${a}${b}` || a || b;
}
